import debounce from 'lodash/debounce';
import { TIME_DEBOUNCE_CALL_API } from 'shared/constants/http';

const debounceFunc = (func, timeCall = TIME_DEBOUNCE_CALL_API) => {
  return debounce(func, timeCall);
};

export default debounceFunc;
